import React from "react";

interface ChevronDownIconProps {
  className?: string;
}

export const ChevronOpenIcon: React.FC<ChevronDownIconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.74997 1.53516V8.03516C9.74997 8.23407 9.67095 8.42483 9.5303 8.56549C9.38965 8.70614 9.19889 8.78516 8.99997 8.78516C8.80106 8.78516 8.6103 8.70614 8.46964 8.56549C8.32899 8.42483 8.24997 8.23407 8.24997 8.03516V3.34766L1.5306 10.0658C1.3897 10.2067 1.19861 10.2858 0.999348 10.2858C0.800091 10.2858 0.608994 10.2067 0.468098 10.0658C0.327202 9.92489 0.248047 9.73379 0.248047 9.53453C0.248047 9.33527 0.327202 9.14418 0.468098 9.00328L7.18747 2.28516H2.49997C2.30106 2.28516 2.11029 2.20614 1.96964 2.06549C1.82899 1.92483 1.74997 1.73407 1.74997 1.53516C1.74997 1.33624 1.82899 1.14548 1.96964 1.00483C2.11029 0.864174 2.30106 0.785156 2.49997 0.785156H8.99997C9.19889 0.785156 9.38965 0.864174 9.5303 1.00483C9.67095 1.14548 9.74997 1.33624 9.74997 1.53516Z"
        fill="#6F6F6F"
      />
    </svg>
  );
};
